import { reducer } from './reducer';
import { sagas } from './sagas';


export const storage = {
    reducer,
    sagas,
};
